import React from 'react';
import Routes from "./Routes";
import { ThemeProviderContainer } from "./theme";

function App() {
  return (
    <ThemeProviderContainer>
      <Routes />
    </ThemeProviderContainer>
  );
}

export default App;
